import { generateUUID } from "utils/utils";
import wretch from "wretch";
import {
  IProductListResponse,
  ICreateSmartfestPaymentLinkResponse
} from "./packageDetails.types";

const BASE_URL = `${process.env.NEXT_PUBLIC_PACKAGES_API_URL}`;

export const getProductsList = ({
  external_id,
  access_token
}: {
  external_id?: string;
  access_token?: string;
}): Promise<IProductListResponse> => {
  const headers: {
    "X-Locale": string;
    "X-IQ-Platform": string;
    Authorization?: string;
    "x-iq-request-id": string;
  } = {
    "X-Locale": "id",
    "X-IQ-Platform": "desktopWeb",
    "x-iq-request-id": generateUUID()
  };
  if (access_token) {
    headers["Authorization"] = `Bearer ${access_token}`;
  }

  return wretch(`${BASE_URL}/api/v1/products/list?external_id=${external_id}`)
    .headers(headers)
    .get()
    .json();
};

export const createSmartfestRegisterPaymentLink = (
  userId: string,
  metaData: Record<string, string> = {}
): Promise<ICreateSmartfestPaymentLinkResponse> => {
  const headers: {
    "X-Locale": string;
    "X-IQ-Platform": string;
    "x-iq-request-id": string;
  } = {
    "X-Locale": "id",
    "X-IQ-Platform": "desktopWeb",
    "x-iq-request-id": generateUUID()
  };

  return wretch(`${BASE_URL}/api/v2/smart_fest/payment_link`)
    .headers(headers)
    .post({
      user_id: userId,
      payment_meta: metaData
    })
    .json();
};
